import { getElements } from 'js-utils/src/selector';
import { getOffset } from 'js-utils/src/position';
import { debounce } from 'js-utils/src/function';

import init from '../../common/base/init';

init(() => {
  const navs = getElements('.hnav');
  if(!navs.length) return;

  const centerOnActiveItem = (nav) => {
    const item = nav.querySelector('.\\--active');
    if(!item) return;
    const pos = nav.scrollLeft + getOffset(item).left - getOffset(nav).left - nav.offsetWidth/2 + item.offsetWidth/2;
    nav.scrollLeft = pos;
  };

  navs.forEach((nav) => {
    window.addEventListener('resize', debounce(300, () => {
      centerOnActiveItem(nav);
    }));

    centerOnActiveItem(nav);
  });
});
